import { z } from 'zod';

/**
 * URL state of the charts page. Kept apart from `model.ts` (which pulls the constructor engine) so the route config,
 * always in the main bundle, imports only this; the page stays in the route's lazy chunk.
 */

/** `/t/:slug/devices/charts?chart=<id>` — the open saved chart (none = "Yangi grafik"). */
export const chartsSearchSchema = z.object({
  chart: z.uuid().optional().catch(undefined),
});
export type ChartsSearch = z.infer<typeof chartsSearchSchema>;
